import { useEffect, useRef, useState } from "react";

export function SignaturePad({ value, onChange, width = 220, height = 72, colors }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasSig, setHasSig] = useState(false);

  useEffect(() => {
    if (value && value.startsWith("data:") && canvasRef.current) {
      const img = new Image();
      img.onload = () => {
        const ctx = canvasRef.current.getContext("2d");
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0);
      };
      img.src = value;
      setHasSig(true);
    }
  }, [value, width, height]);

  const getPos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    return {
      x: (e.clientX - rect.left) * scaleX,
      y: (e.clientY - rect.top) * scaleY,
    };
  };

  const onDown = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e, canvasRef.current);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
    e.preventDefault();
  };

  const onMove = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e, canvasRef.current);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#111827";
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    setHasSig(true);
    e.preventDefault();
  };

  const onUp = () => {
    if (drawing.current && hasSig) {
      onChange(canvasRef.current.toDataURL());
    }
    drawing.current = false;
  };

  const clear = (e) => {
    e.stopPropagation();
    const ctx = canvasRef.current.getContext("2d");
    ctx.clearRect(0, 0, width, height);
    setHasSig(false);
    onChange(null);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        onMouseDown={onDown}
        onMouseMove={onMove}
        onMouseUp={onUp}
        onMouseLeave={onUp}
        style={{
          border: `1.5px solid ${colors.border}`,
          borderRadius: 4,
          background: colors.bg,
          cursor: "crosshair",
          display: "block",
          width,
          height,
        }}
      />
      {!hasSig && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            color: "#9ca3af",
            fontSize: 13,
          }}
        >
          Draw signature here
        </div>
      )}
      {hasSig && (
        <button
          onClick={clear}
          style={{
            position: "absolute",
            top: 4,
            right: 4,
            background: "white",
            border: "1px solid #e5e7eb",
            borderRadius: 4,
            cursor: "pointer",
            padding: "2px 8px",
            fontSize: 11,
            color: "#6b7280",
          }}
        >
          Clear
        </button>
      )}
    </div>
  );
}
